<button mat-icon-button class="close-button " mat-dialog-close>
    <mat-icon class="primary-background-element secondary-border-element close-icon secondary-icon" svgIcon="close" ></mat-icon>
  </button>
<div class="fixActionRow">
    <ng-container *ngComponentOutlet="component ">
    </ng-container>
</div>